import { Controller } from "@hotwired/stimulus"

// A custom part's folded row on the edit page: keeps its name, maker · from,
// slot and procured tag in step with the form under it as you edit.
export default class extends Controller {
  static targets = ["name", "meta", "slot", "procured"]

  connect() {
    this.refresh = this.refresh.bind(this)
    this.element.addEventListener("input", this.refresh)
    this.element.addEventListener("change", this.refresh)
  }

  disconnect() {
    this.element.removeEventListener("input", this.refresh)
    this.element.removeEventListener("change", this.refresh)
  }

  refresh() {
    const field = (name) => this.element.querySelector(`[name='custom_part[${name}]']`)
    this.nameTarget.textContent = field("display_name")?.value || ""
    this.metaTarget.textContent = [field("maker")?.value, field("source")?.value].filter((v) => v && v.trim()).join(" · ")
    const slot = field("slot")
    if (slot) this.slotTarget.textContent = slot.options[slot.selectedIndex]?.text || ""
    const got = this.element.querySelector("input[type=checkbox][name='custom_part[procured]']")?.checked
    this.procuredTarget.textContent = got ? "Procured" : "Need to procure"
    this.procuredTarget.classList.toggle("is-got", !!got)
  }
}
